import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMomentsBusinesses = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/businesses/show.vue')
    createVueApp(ShowPage, { props })
  }
}
